import Dashboard from './Dashboard';

export { Dashboard };
export default {
  Dashboard,
};
